import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { State } from 'v2/data-store/state';

import { IChannel } from '../shared/interfaces/mtchannel.interface';

import { IChannelState } from './interfaces';

const INITIAL_STATE :IChannelState = {
  channels: [],
  currentChannel: null,
  meta: null,
  loading: false,
  submitting: false,
  currentQueryParams: {
    limit: '20',
    page: '1',
    sortField: 'created_at',
    sortDirection: 'desc',
    relations: [
      'pullOrderIntegrationMapping.appIntegrationAccount',
      'pullOrderIntegrationMapping.store',
      'pushOrderIntegrationMapping.appIntegrationAccount',
      'pushOrderIntegrationMapping.store',
      'warehouseGroup',
      'tags',
      'pushStockIntegrationMapping.appIntegrationAccount',
    ].join(','),
    status: '1',
  },
};

@Injectable({
  providedIn: 'root',
})
export class ChannelStateService extends State<IChannelState> {
  readonly channels$ :Observable<IChannel[]> = this.observe('channels');
  readonly loading$ :Observable<boolean> = this.observe('loading');
  readonly submitting$ :Observable<boolean> = this.observe('submitting');
  readonly currentChannel$ :Observable<IChannel | null> =
    this.observe('currentChannel');

  constructor() {
    super(INITIAL_STATE);
  }
}
